import React from 'react'

import './style.css'

const Header = () => (
    <div className="Header">
        <header>
            <h1>cefetmg-samp</h1>
        </header>
    </div>
);

export default Header;
